<div class="wrap">
  <div class="header">
    <h1>ANPR License management</h1>
    <!-- <p>Test requête API {{ licenses }}</p> -->
    <div class="add_license_and_search_bar">
      <div class="add_Licenses" (click)="openAddLicenseDialog()">
        <span></span>
        <div class="fa-icon-container">
          <fa-icon [icon]="faPlus" class="faPlus"></fa-icon>
        </div>
      </div>

      <div class="search_bar">
        <input
          matInput
          placeholder="Search a customer"
          #input
          (keyup)="applyFilter($event)"
        />
      </div>
    </div>
  </div>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="client">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [style.text-align]="'left'"
        >
          Customer
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'left'">
          {{ element.client.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.text-align]="'left'"
          mat-sort-header
        >
          Type
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'left'">
          {{ element.type.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="startingDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.text-align]="'left'"
          mat-sort-header
        >
          Starting date
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'left'">
          {{ element.startingDate | date : "shortDate" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="expiryDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.text-align]="'left'"
          mat-sort-header
        >
          Expiry date
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'left'">
          <div *ngIf="element.expiryDate; else endless">
            {{ element.expiryDate | date : "shortDate" }}
          </div>
          <ng-template #endless>
            <mat-icon
              aria-hidden="false"
              aria-label="infinity icon"
              fontIcon="
              minimize"
              class="see-icon"
            ></mat-icon
          ></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.text-align]="'left'"
          mat-sort-header
        >
          Status
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'left'">
          {{ element.status.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usesRemaining">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Uses remaining
        </th>

        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <div
            *ngIf="
              element.type === 'Unlimited' || element.usesRemaining == null;
              else limited
            "
          >
            <mat-icon
              aria-hidden="false"
              aria-label="infinity icon"
              fontIcon="all_inclusive"
              class="see-icon"
            ></mat-icon>
          </div>
          <ng-template #limited>
            {{ element.usesRemaining }}
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Comment
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <div *ngIf="element.comment">
            <fa-icon
              class="see-icon"
              aria-hidden="false"
              aria-label="infinity icon"
              [icon]="faEye"
              matTooltip="{{ element.comment }}"
              [matTooltipPosition]="'above'"
              matTooltipShowDelay="70"
            ></fa-icon>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
          Actions
        </th>

        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <button mat-button [matMenuTriggerFor]="menu">
            <fa-icon [icon]="faMenu" class="edit-icon"></fa-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openUpdateLicenseDialog(element)">
              <fa-icon [icon]="faEdit" class="edit-icon" />
              <span> Update </span>
            </button>
            <button
              mat-menu-item
              *ngIf="element.status.id != 2"
              (click)="openEndLicense(element)"
            >
              <fa-icon
                class="edit-icon"
                aria-hidden="false"
                aria-label="infinity icon"
                [icon]="faEnd"
              ></fa-icon>
              <span> End license </span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 25, 100]"
      aria-label="Select page of licenses"
    ></mat-paginator>
  </div>
</div>
